module.exports = __webpack_public_path__ + "img/375.1c3fe5f6.jpg";